import * as Sentry from '@sentry/react'

if (process.env.NODE_ENV === 'production') {
	Sentry.init({
		dsn: 'https://a7acf0be119e0595005c8b8564d12b4d@o4504810962878464.ingest.us.sentry.io/4509431248191488',
		sendDefaultPii: true,
	})
}
